import { defineConfig } from 'cva';
import { extendTailwindMerge } from 'tailwind-merge';
import { boxShadow } from '../theme/elevation';

/**
 * A helper function to ensure that the custom font size and shadow classes are merged when using the `cva` utility.
 *
 * tailwind-merge only recognises t-shirt sizes as `shadow-*` sizes; any other
 * name is treated as a shadow *color*, so `shadow-radio-button-focused` would
 * otherwise be kept alongside `shadow-xs` and lose to it in the compiled CSS
 * order.
 */
export const merge = extendTailwindMerge({
  extend: {
    classGroups: {
      shadow: [{ shadow: Object.keys(boxShadow) }],
      'font-size': [
        {
          text: [
            'xxs',
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            'caption',
            'body-sm',
            'body-sm-compact',
            'body-md',
            'body-md-compact',
            'body-lg',
            'body-lg-compact',
            'heading-1',
            'heading-2',
            'heading-3',
            'heading-4',
            'display-xs',
            'display-sm',
            'display-md',
            'display-lg',
            'display-xl',
            'display-2xl',
          ],
        },
      ],
      'font-weight': [{ font: ['regular'] }],
    },
  },
});

/**
 * A set of utilities for working with the design system theme in Tailwind CSS.
 */
export const { cva, cx, compose } = defineConfig({
  hooks: {
    onComplete: (className) => merge(className),
  },
});

export type { VariantProps } from 'cva';
